module.exports = __webpack_public_path__ + "images/category_lp/earphone/new/assessment_achievements/6@2x_fe6e59c945378807c55aaa74f57ebf7a.png";